// extracted by mini-css-extract-plugin
export default {"availabilityBox":"availabilityBox-Y9lOt"};